import { Form, Input } from 'antd';
import { OverrideApproverSelect } from '../../jobs/public/OverrideApproverSelect';
import type { DecisionMode } from '../policies/expense-decision';

const REASON_MAX = 500;
const REASON_LABELS: Partial<Record<DecisionMode, string>> = { reject: 'Why is it rejected?', exception: 'Why is it approved without a receipt?' };

/** What a decision asks for beyond the click: nothing to approve, a reason to reject, a reason and a second person for an exception. */
export function ExpenseDecisionFields({ mode }: { mode: DecisionMode }) {
  if (mode === 'approve') return null;
  return (
    <>
      <Form.Item name="reason" label={REASON_LABELS[mode]} rules={[{ required: true, whitespace: true, message: 'Give a reason' }]}>
        <Input.TextArea rows={3} maxLength={REASON_MAX} />
      </Form.Item>
      {mode === 'exception' && (
        <Form.Item
          name="overrideApproverId"
          label="Second approver"
          extra="Someone else who can approve overrides signs this off with you."
          rules={[{ required: true, message: 'Choose who signs this off with you' }]}
        >
          <OverrideApproverSelect />
        </Form.Item>
      )}
    </>
  );
}
